import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/machines'

export default {
  edit(id, machine) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, machine)
  },
  create(machine) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, machine)
  },
  getMachine(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  getList(page, per_page, search, date_ini, date_fin, project) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      page,
      per_page,
      search,
      date_ini,
      date_fin,
      project_id: project,
    })
  },
}
